import * as turf from "@turf/turf";
import { getName } from "../components/util";
import { unitsEnum } from "./const";

const schema = {
  type: "object",
  title: "Create buffer around feature",
  properties: {
    radius: { type: "integer", title: "Distance of buffer" },
    options: {
      type: "object",
      properties: {
        units: {
          type: "string",
          ...unitsEnum,
          title: "Units for distance of buffer. Negative values allowed."
        },
        steps: { type: "integer", title: "Number of steps" }
      }
    }
  }
};

const ui = {
  // radius: { "ui:widget": "textarea" }
  //   options: {
  //     units: { "ui:widget": "textarea" },
  //     steps: { "ui:widget": "textarea" }
  //   }
};

const fn = ({ addLayer, layer, formData, handleClose }) => {
  const buffer = turf.buffer(layer, Number(formData.radius), formData.options);
  addLayer({
    layer: Object.assign({}, buffer),
    name: `Buffer from ${getName(layer)}`
  });
  handleClose();
};

const initial = { radius: 10, options: { units: "kilometers", steps: 64 } };

export const bufferForm = { initial, ui, schema, fn };
